// extracted by mini-css-extract-plugin
module.exports = {"message":"j1Xo7hbYKvoYlkzU9JZSc"};